<app-steps [step]='2'></app-steps>

<div class="row">
  <div class="col">
    <h3 class="main-title text-center">Select a Practitioner</h3>
  </div>
</div>

<div class="row">
  <div class="col carosel">
    <div class="card-header custom-card-header rounded-0" *ngFor="let practitioner of therapists">
      <div class="row">
        <div class="col-md-6" style="padding-top: 5px;">
          <span *ngIf="practitioner.title!='' && practitioner.title!=null">{{practitioner.title}}.
          </span><span>{{practitioner.firstName}}&nbsp;{{practitioner.lastName}}</span>
        </div>
        <div class="col-md-6 text-right">
          <button class="btn btn-select btn-blue btn-sm" (click)="setSelectedPractitioner(practitioner)">Select &nbsp;<i
              class="fas fa-chevron-right"></i></button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row nav-footer">
  <div class="col text-center">
    <button class="btn btn-blue" (click)="back()"><i class="fas fa-chevron-left"></i>&nbsp;Back</button>
  </div>
</div>